<div class="wells-container">
    <div class="header-section">
        <h1 class="wells-title">Wells</h1>
        <button mat-raised-button color="primary" (click)="loadWells()">
            <mat-icon>refresh</mat-icon>
            Refresh
        </button>
    </div>

    <div *ngIf="loading" class="loading-container">
        <mat-spinner></mat-spinner>
        <p>Loading wells...</p>
    </div>

    <div *ngIf="error && !loading" class="error-container">
        <mat-icon class="error-icon">error</mat-icon>
        <p>{{ error }}</p>
        <button mat-raised-button color="primary" (click)="loadWells()">Retry</button>
    </div>

    <div *ngIf="!loading && wells.length > 0" class="wells-grid">
        <mat-card *ngFor="let well of wells" class="well-card" (click)="onNavigateToCanvas(well)">
            <div class="card-header-row">
                <mat-icon class="well-icon">oil_barrel</mat-icon>
                <div class="card-header-info">
                    <span class="well-name">{{ well.name }}</span>
                    <span *ngIf="well.status" class="status-badge"
                        [style.background-color]="getStatusColor(well.status)">
                        {{ well.status }}
                    </span>
                </div>
            </div>
            <mat-divider></mat-divider>
            <div class="map-container">
                <img [src]="mapUrlImage" alt="Well location map">
            </div>
            <mat-divider></mat-divider>
            <mat-card-content class="well-details">
                <div class="detail-row">
                    <mat-icon class="detail-icon">business</mat-icon>
                    <span class="detail-label">Operator</span>
                    <span class="detail-value">{{ getOperator(well) }}</span>
                </div>
                <div class="detail-row">
                    <mat-icon class="detail-icon">pin_drop</mat-icon>
                    <span class="detail-label">Latitude</span>
                    <span class="detail-value">{{ well.well_Latitude != null ? (well.well_Latitude | number:'1.4-6') :
                        '\u2014' }}</span>
                </div>
                <div class="detail-row">
                    <mat-icon class="detail-icon">pin_drop</mat-icon>
                    <span class="detail-label">Longitude</span>
                    <span class="detail-value">{{ well.well_Longitude != null ? (well.well_Longitude | number:'1.4-6') :
                        '\u2014' }}</span>
                </div>
                <div class="detail-row">
                    <mat-icon class="detail-icon">height</mat-icon>
                    <span class="detail-label">KB Elevation</span>
                    <span class="detail-value">{{ well.kbelevation_ft != null ? (well.kbelevation_ft | number:'1.1-2') +
                        ' ft' : '\u2014' }}</span>
                </div>
                <div class="detail-row">
                    <mat-icon class="detail-icon">straighten</mat-icon>
                    <span class="detail-label">Depth (MD)</span>
                    <span class="detail-value">{{ well.total_depth_md_ft != null ? (well.total_depth_md_ft |
                        number:'1.1-2') + ' ft' : '\u2014' }}</span>
                </div>
                <div class="detail-row">
                    <mat-icon class="detail-icon">straighten</mat-icon>
                    <span class="detail-label">Depth (TVD)</span>
                    <span class="detail-value">{{ well.total_depth_tvd_ft != null ? (well.total_depth_tvd_ft |
                        number:'1.1-2') + ' ft' : '\u2014' }}</span>
                </div>
                <div class="detail-row">
                    <mat-icon class="detail-icon">calendar_today</mat-icon>
                    <span class="detail-label">Spud Date</span>
                    <span class="detail-value">{{ well.spud_date ? (well.spud_date | date:'mediumDate') : '\u2014'
                        }}</span>
                </div>
            </mat-card-content>
        </mat-card>
    </div>

    <div *ngIf="!loading && wells.length === 0" class="empty-message">
        No wells found.
    </div>
</div>